import {
    computed,
    ComputedRef,
    inject,
    MaybeRefOrGetter,
    provide,
    shallowRef,
    toValue,
    watchEffect,
} from "vue";
import { packed } from "magnetar-common";

export const pageMetadataCallback = Symbol("setPageMetadata");
export const pageMetadataProvider = Symbol("pageMetadataProvider");

export type PageMetadata = {
    title: string;
    subtitle?: string;
    icon?: string | null;
    avatar?: packed.PackUserBase | null;
    userName?: packed.PackUserBase | null;
    bg?: string;
};

export function definePageMetadata(
    metadata: MaybeRefOrGetter<PageMetadata | null>
): void {
    const meta = computed(() => toValue(metadata));

    const set =
        inject<(m: ComputedRef<PageMetadata | null>) => void>(
            pageMetadataCallback
        );

    watchEffect(() => {
        if (set) {
            set(meta);
        }
    });
}

export function providePageMetadata(): ComputedRef<PageMetadata | null> {
    const metadata = shallowRef<ComputedRef<PageMetadata | null> | null>(null);

    provide(pageMetadataCallback, (info: ComputedRef<PageMetadata>) => {
        metadata.value = info;
    });

    const computedMeta = computed(() => metadata.value?.value ?? null);
    provide(pageMetadataProvider, computedMeta);

    return computedMeta;
}

export function usePageMetadata(): ComputedRef<PageMetadata | null> {
    return inject(pageMetadataProvider) ?? computed(() => null);
}
